import * as React from 'react';
import type { HelpTopic } from '@chess/api-help';

// The help topic behind the card's "?": how a game lands in a slice, in
// plain words. Registered by this plugin's setup.
export const ENDING_RESULTS_HELP = 'ending.results';

export const endingResultsHelp: HelpTopic = {
  title: 'Ending results',
  body: (
    <>
      <p>
        Every scanned game of the last 30 days that reached the ending is in exactly one slice, from two readings of your position: how the game started and how
        it ended.
      </p>
      <h3>Winning, level or lost</h3>
      <p>
        Your score is read in pawns from your side. At the <b>Winning</b> value in your Blunders and misses settings or more (+2 by default) you stand
        <b> winning</b>; at minus that or less, <b>lost</b>; anywhere between, <b>level</b>. The start is your score at the first move of the ending; the end is
         how the game ended: a win counts as winning, a draw as level, a loss as lost (a loss on time included).
      </p>
      <h3>The slices</h3>
      <ul>
        <li><b>Won</b>: won from a winning or level start.</li>
        <li><b>Comeback</b>: won or drew from a lost start.</li>
        <li><b>Drawn</b>: drew from a level start.</li>
        <li><b>Blown win</b>: drew or lost from a winning start.</li>
        <li><b>Lost</b>: lost from a level or lost start.</li>
      </ul>
      <p>
        So an advantage under the Winning value (say +1 out of the opening) counts as level: if it then collapses, the game is in the last slice, not the
        blown one. Clicking a slice opens exactly those games in the library.
      </p>
    </>
  ),
};
